import PropTypes from "prop-types";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function CardTitle({ title }) {
  return (
    <MDBox display="flex" alignItems="center" height="4rem">
      {/* <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="3rem"
        height="3rem"
        variant="gradient"
        shadow="md"
        borderRadius="xl"
        mt={2}
        ml={3}
        {...rest}
      >
        <Icon fontSize="medium" color="inherit">
          {icon}
        </Icon>
      </MDBox> */}
      <MDTypography variant="h4" sx={{ mt: 2, ml: 3 }}>
        {title.toUpperCase()}
      </MDTypography>
    </MDBox>
  );
}

CardTitle.defaultProps = {
  // color: "white",
  // bgColor: "info",
};

CardTitle.propTypes = {
  // icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  // color: PropTypes.string,
  // bgColor: PropTypes.string,
};

export default CardTitle;
